module.exports = __webpack_public_path__ + "img/AWF_Logo_Colored.8385be06.png";